export function sumBy<
  TItem extends Record<TProperty, number>,
  TProperty extends keyof TItem,
>(items: TItem[], property: TProperty): number {
  return items.reduce((acc: number, item: TItem) => acc + item[property], 0);
}
